import $ from 'jquery';

const defaults = {
  selector: '.node-inner',
  destination: undefined,
  placeholder: undefined,
  optionSrc: '.node-header',
  target: 'a',
  numerator: undefined,
  after: false,
  label: undefined,
};

function SelectList(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.init();
}

SelectList.prototype = {
  init() {
    const placeholder = (this.settings.placeholder)
      ? this.settings.placeholder
      : this.$element.find('.node-header .title').text();
    const $destination = (this.settings.destination)
      ? this.$element.find(this.settings.destination)
      : this.$element;
    if (this.settings.after) {
      $destination.append(`<div class="dynamic-select-wrapper"><select id="dynamic_select_${this.settings.numerator}" class="dynamic-select" onchange="document.location.href=this.value" aria-labeledby="${this.settings.label}"><option value="" disabled hidden selected>${placeholder}</option></select></div>`);
    } else {
      $destination.prepend(`<div class="dynamic-select-wrapper"><select id="dynamic_select_${this.settings.numerator}" class="dynamic-select" onchange="document.location.href=this.value" aria-labeledby="${this.settings.label}"><option value="" disabled hidden selected>${placeholder}</option></select></div>`);
    }
    this.$element.find(this.settings.optionSrc).each((i, elem) => {
      const target = $(elem).find(this.settings.target);
      const targetUrl = $(target).attr('href');
      const targetLabel = $(target).text();
      this.$element.find(`#dynamic_select_${this.settings.numerator}`).append(`<option value="${targetUrl}">${targetLabel}</option>`);
    });
  },
};

export default SelectList;
